import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import ContactForm from './ContactForm';
import { contactForms as tabs } from '../data/contactForms';

function ContactPage({ initialTab = 'general', confirmation = false }) {
  const active = tabs.find((tab) => tab.key === initialTab) || tabs[0];

  return (
    <>
      <Hero
        eyebrow="Contact C+M"
        title="Contact"
        description="Send C+M the request details needed for general questions, baler quotes, questionnaire review, or baling wire quotation."
        image="banner/4.jpg"
      />
      <main>
        <section className="contact-mega">
          <aside className="contact-sidebar">
            <span className="eyebrow">Request type</span>
            <h2>How can we help?</h2>
            <p>Choose the form that best matches your request. The fields will adjust so C+M receives the right <strong>application details</strong>.</p>
            <nav className="contact-tabs" aria-label="Contact request type">
              {tabs.map((tab) => (
                <Link
                  key={tab.key}
                  to={tab.path}
                  aria-current={active.key === tab.key ? 'page' : undefined}
                  className={active.key === tab.key ? 'active' : ''}
                >
                  <span>{tab.label}</span>
                  <ArrowRight size={15} />
                </Link>
              ))}
            </nav>
            <div className="contact-card">
              <b>C+M Baling Systems</b>
              <a href="tel:8002253796">(800) 225-3796</a>
              <a href="tel:3367238850">(336) 723-8850</a>
              <div className="contact-email-list">
                <span>Price Quotations</span>
                <a href="mailto:sales@baling.com">sales@baling.com</a>
                <span>Brochures &amp; Literature</span>
                <a href="mailto:marketing@baling.com">marketing@baling.com</a>
                <span>Replacement Parts</span>
                <a href="mailto:parts@baling.com">parts@baling.com</a>
              </div>
              <p>Winston-Salem, North Carolina</p>
            </div>
          </aside>

          {confirmation ? (
            <div id="contact-form" className="form-protection-gate">
              <div className="mega-form">
                <div className="success">
                  <CheckCircle2 size={38} />
                  <h3>Thank you.</h3>
                  <p>Your {active.label.toLowerCase()} details are ready for the <strong>C+M team</strong>.</p>
                </div>
              </div>
            </div>
          ) : (
            <ContactForm initialTab={active.key} />
          )}
        </section>
      </main>
    </>
  );
}

export default ContactPage;
